export const enumOptions = (enums, int) => Object.keys(enums).map((v) => ({
  label: enums[v],
  value: int ? int[v] : v,
}));
